import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Title } from "react-admin";

export default () => (
    <Card>
        <Title title="Not Found"/>
        <CardContent>
            <h1>404: Page not found</h1>
            <img width="100%" src="/Main_D4c_white2.jpg"/>
        </CardContent>
    </Card>
);